// REACT IMPORTS
import React, { useEffect } from "react";
import Header from "components/layout/header";
import { useUserData } from "store/slices/authSlice";
import DashboardPage from "components/dashboard/DashboardPage";
import { paymentLogoGet } from "store/slices/paymentsSlice";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { useParams } from "react-router-dom";
import { decode } from "utils/HelperFunctions";
import { RootState } from "store/store";

/* ------------------------------------- DASHBOARD PAGE ------------------------------------- */
const Dashboard = () => {
  const userData = useUserData();
  const dispatch = useAppDispatch();
  const { paymentLogo } = useAppSelector((state: RootState) => state.payment);
  const { isDashPreview } = useAppSelector((state: RootState)=>state.dashboard)
  const { clusterId: cluster_id } = useParams();
  const clusterId = decode(cluster_id || "", true);

  const onGetLogo = async () => {
    try {
      let payload = {
        cluster_id: clusterId,
      };
      await dispatch(paymentLogoGet(payload)).unwrap();
    } catch (error: any) {
      console.log("get logo err: -->", error?.message);
    }
  };

  useEffect(() => {
    if (!paymentLogo && clusterId) onGetLogo();
  }, [paymentLogo, clusterId]);

  return (
    <div className="w-full h-full lg:block flex flex-col lg:overflow-hidden overflow-y-auto">
      {!isDashPreview && <Header
      headerclassName="lg:pr-2.5"
        headerContent={
          <div className="w-full lg:text-[32px] sm:text-3xl text-2xl leading-[44px] text-txtPrimary font-medium -tracking-[0.72px] lg:p-0 p-5">
            Welcome, {userData?.data?.accountData?.first_name || ""}!
          </div>
        }
      />}

      <div className="lg:pt-[93px] h-full lg:px-0 lg:pr-10 lg:overflow-y-scroll">
        <DashboardPage />
      </div>
    </div>
  );
};

export default Dashboard;
